import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createSafeContext } from '@mantine/utils';
import { POPOVER_ERRORS } from './Popover.errors.js';
var _createSafeContext = createSafeContext(POPOVER_ERRORS.context),
  _createSafeContext2 = _slicedToArray(_createSafeContext, 2),
  PopoverContextProvider = _createSafeContext2[0],
  usePopoverContext = _createSafeContext2[1];
export { PopoverContextProvider, usePopoverContext };